module.exports = __webpack_public_path__ + "static/img/img-Analysis2.3f753d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-Analysis2.png
// module id = dpxD
// module chunks = 1